import React, { useState, useCallback } from 'react';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { GrClose } from 'react-icons/gr';
import client from "../../../../services/Api";
import swal from 'sweetalert';
import { Button, Form, FormControl, InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
    useGoogleReCaptcha
  } from 'react-google-recaptcha-v3';

import './index.css'

function ContactModal(){
    const { register, handleSubmit} = useForm();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [token, setToken] = useState('');
    const [noOfVerifications, setNoOfVerifications] = useState(0);
    const [dynamicAction, setDynamicAction] = useState('homepage');
    const [actionToChange, setActionToChange] = useState('');

    const closeModal = () => {
        ModalManager.close()
        // body.style.overflow = 'auto'
    }

    const style = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 99999999,
          overflowX: 'hidden',
          overflowY: 'auto',
          perspective: 1300,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
    
        content: {
          position: 'relative',
          border: '1px solid rgba(0, 0, 0, .2)',
          width: 'inherit',
          background: '#fff',
          overflow: 'auto',
          borderRadius: '4px',
          outline: 'none',
          boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
        }
    }

    const onSubmitMessage = async (message) =>{
        closeModal();
        if(token === '')
            return;
        try {
            const response = await client.post('/api/contact-us', message)
            swal("Mensagem enviada com sucesso!", {
                title: "Sucesso!",
                icon: "success",
            })
        } catch (e) {
            console.log(e);
            swal("Erro!", "Não foi possível enviar a mensagem, tente novamente", "error");
        }

    }

    
      const handleReCaptchaVerify = useCallback(
        token => {
          setToken(token);
          setNoOfVerifications(noOfVerifications => noOfVerifications + 1);
        },
        [setNoOfVerifications, setToken]
      );
    
    return(
        <div className="ContactModal">
            <Modal
            style={style}
            onRequestClose={() => { }}
            effect={Effect.Fall}>
                <div className="header">
                    <div className="title">
                        Entre em contato
                    </div>

                    <div className="actions">
                        <GrClose onClick={closeModal} />
                    </div>
                </div>

                <div className="body">
                    <GoogleReCaptchaProvider reCaptchaKey="6LfhXkgaAAAAANZlizS8p5BrJ3qs-xZvBjR86l4A">
                        <div className="ContactForm">
                            <Form onSubmit={handleSubmit(onSubmitMessage)}>
                                <Form.Label>Nome</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        placeholder="informe o seu nome"
                                        type="text"
                                        name="name"
                                        required
                                        ref={register}
                                        className="form-input"
                                    />
                                </InputGroup>
                                <Form.Label>Email</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        placeholder="informe o seu email"
                                        type="text"
                                        name="email"
                                        required
                                        ref={register}
                                        className="form-input"
                                    />
                                </InputGroup>
                                <Form.Label>telefone</Form.Label>
                                <InputGroup>
                                    <ReactInputMask
                                        placeholder="informe o seu telefone"
                                        type="text"
                                        name="phone"
                                        required
                                        inputRef={register}
                                        mask="(99) 99999-9999"
                                        className="form-input form-control"
                                    />
                                </InputGroup>
                                <Form.Label>Mensagem</Form.Label>
                                <InputGroup>
                                    <Form.Control as="textarea" rows={3}
                                        placeholder="digite o texto"
                                        type=""
                                        name="message"
                                        required
                                        ref={register}
                                        className="form-input"
                                    />
                                </InputGroup>
                                <InputGroup>
                                    <Button variant="primary" type="submit">
                                        Enviar
                                    </Button>
                                </InputGroup>
                            </Form>
                            <GoogleReCaptcha action={dynamicAction}
                                onVerify={handleReCaptchaVerify} />
                        </div>
                    </GoogleReCaptchaProvider>
                </div>
            </Modal>
        </div>
    );

}

export default ContactModal;